<template>
  <div id="document-move-dialog-foldertreelist" class="list-tree p-0 h-fit overflow-hidden">
    <tree-template
      :folder="{
        name: vesselName,
        path: selectedItemId,
        isOpen: isOpen
      }"
      :switchOpenMethod="toggleSwitchOpen"
      :selectedMethod="toggleTreeSelect"
      :isSelected="isSelected"
    >
      <template #child>
        <folder-tree-item :folders="moveDialogFolders" :validate="validate"/>
      </template>
    </tree-template>
  </div>
</template>

<script>
import TreeTemplate from "../../../tree/DocumentFolderTemplate"
import FolderTreeItem from "./DocumentMoveDialogTreeItem"
import { createNamespacedHelpers } from "vuex";

const {
  mapActions: mapActionsOfenterpriseDocumentManager,
  mapMutations: mapMutationsOfenterpriseDocumentManager,
  mapState: mapStateOfenterpriseDocumentManager
} = createNamespacedHelpers("enterpriseDocumentManager");



export default {
  name: "FolderTreeList",
  props: {
    validate: {type: Function}
  },
  components: {
    TreeTemplate,
    FolderTreeItem,
  },
  data () {
    return {
      isOpen: true,
      selectedItemId: "tree-root",
      scrollSettings: {
        maxScrollbarLength: 20,
      },
    }
  },
  computed: {
    ...mapStateOfenterpriseDocumentManager([
      "vesselName", "selectedMoveDialogFolderPath", "moveDialogFolders"
    ]),
  },
  methods: {
    ...mapMutationsOfenterpriseDocumentManager([
      "SET_SELECTED_MOVE_DIAROG_FOLDER",
      "SET_DOCUMENT_NEW_PATH"
    ]),
    ...mapActionsOfenterpriseDocumentManager([
      "fetchRootMoveDialogFolders"
    ]),
    toggleSwitchOpen () {
      this.isOpen = !this.isOpen;
    },
    async toggleTreeSelect () {
      try {
        this.SET_DOCUMENT_NEW_PATH("")
        this.SET_SELECTED_MOVE_DIAROG_FOLDER(this.selectedItemId)
        this.validate("");
        this.isOpen = true;
      } catch (error) {
        console.error(error)
        throw error;
      }
    },
    isSelected (path) {
      return this.selectedMoveDialogFolderPath === path
    },
  },
  mounted () {
    this.fetchRootMoveDialogFolders()
  },
  created () {
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
</style>